// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .review-meetings {
    width: 80%;
    margin: 0 auto;
  }
  
  .review-meetings h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .review-meetings table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .review-meetings table thead th {
    background-color: #f4f4f4;
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
  }
  
  .review-meetings table tbody td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
  }
  
  .review-meetings table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .review-meetings table tbody tr:hover {
    background-color: #f1f1f1;
  }
  
  .review-meetings table input[type="checkbox"] {
    transform: scale(1.2);
  }
  .table-heading th{
    text-align:center;
    
  } */
   .contain{
    margin: 50px;
   }

  .review-meetings {
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }
  
  .review-meetings h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .review-meetings table {
    width: 90%;
    border-collapse: collapse;
    margin: 0px auto 0px auto;
  }
  
  .review-meetings table thead th {
    background-color: #f4f4f4;
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
  }
  
  .review-meetings table tbody td {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: center;
  }
  
  .review-meetings table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .review-meetings table tbody tr:hover {
    background-color: #f1f1f1;
  }
  
  .review-meetings table input[type='checkbox'] {
    transform: scale(1.2);
  }
  
  .table-heading th {
    padding-left: 0;
    text-align: center;
  }
  
  .view-attendance-heading {
    position: sticky;
    top: 60px; /* adjust based on your navbar height */
    /* z-index: 10; */
    /* background-color: white; match your page background */
    /* padding: 15px 0; */
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    /* border-bottom: 1px solid #ccc; */
  }
  
  
  .mobile-scroll-table-wrapper {
    overflow-x: auto;
    width: 100%;
  }
  
  .mobile-scroll-table {
    min-width: 600px;
    border-collapse: collapse;
    width: max-content;
  }
  
  .mobile-scroll-table th,
  .mobile-scroll-table td {
    white-space: nowrap;
    text-align: center;
    padding: 8px;
    border: 1px solid #ccc;
  }
  
  .mobile-scroll-table .sticky-col {
    position: sticky;
    left: 0;
    background: #fff;
    z-index: 2;
  }
  
  
  
  /* Responsive behavior */
  @media (max-width: 768px) {
    .contain{
      margin: 20px;
      margin-top: 0px;
     }

    .view-attendance-heading {
      display: none;
    }
  
    .hide-on-mobile {
      display: none;
    }
  
    .mobile-scroll-table-wrapper {
      display: block;
    }

    .desktop-table-wrapper {
      display: none;
    }
  
    .mobile-scroll-table {
      display: block;
      overflow-x: auto;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/ViewMeetings.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA0CK;GACF;IACC,YAAY;GACb;;EAED;IACE,WAAW;IACX,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,SAAS,EAAE,uCAAuC;IAClD,iBAAiB;IACjB,wDAAwD;IACxD,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mCAAmC;EACrC;;;EAGA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,OAAO;IACP,gBAAgB;IAChB,UAAU;EACZ;;;;EAIA,wBAAwB;EACxB;IACE;MACE,YAAY;MACZ,eAAe;KAChB;;IAED;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;MACd,gBAAgB;IAClB;EACF","sourcesContent":["/* .review-meetings {\n    width: 80%;\n    margin: 0 auto;\n  }\n  \n  .review-meetings h2 {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .review-meetings table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .review-meetings table thead th {\n    background-color: #f4f4f4;\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n  }\n  \n  .review-meetings table tbody td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n  }\n  \n  .review-meetings table tbody tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .review-meetings table tbody tr:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .review-meetings table input[type=\"checkbox\"] {\n    transform: scale(1.2);\n  }\n  .table-heading th{\n    text-align:center;\n    \n  } */\n   .contain{\n    margin: 50px;\n   }\n\n  .review-meetings {\n    width: 100%;\n    margin: 0 auto;\n    padding: 0;\n  }\n  \n  .review-meetings h2 {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .review-meetings table {\n    width: 90%;\n    border-collapse: collapse;\n    margin: 0px auto 0px auto;\n  }\n  \n  .review-meetings table thead th {\n    background-color: #f4f4f4;\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n  }\n  \n  .review-meetings table tbody td {\n    padding: 10px;\n    border: 1px solid #ddd;\n    text-align: center;\n  }\n  \n  .review-meetings table tbody tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n  \n  .review-meetings table tbody tr:hover {\n    background-color: #f1f1f1;\n  }\n  \n  .review-meetings table input[type='checkbox'] {\n    transform: scale(1.2);\n  }\n  \n  .table-heading th {\n    padding-left: 0;\n    text-align: center;\n  }\n  \n  .view-attendance-heading {\n    position: sticky;\n    top: 60px; /* adjust based on your navbar height */\n    /* z-index: 10; */\n    /* background-color: white; match your page background */\n    /* padding: 15px 0; */\n    text-align: center;\n    font-size: 24px;\n    font-weight: bold;\n    /* border-bottom: 1px solid #ccc; */\n  }\n  \n  \n  .mobile-scroll-table-wrapper {\n    overflow-x: auto;\n    width: 100%;\n  }\n  \n  .mobile-scroll-table {\n    min-width: 600px;\n    border-collapse: collapse;\n    width: max-content;\n  }\n  \n  .mobile-scroll-table th,\n  .mobile-scroll-table td {\n    white-space: nowrap;\n    text-align: center;\n    padding: 8px;\n    border: 1px solid #ccc;\n  }\n  \n  .mobile-scroll-table .sticky-col {\n    position: sticky;\n    left: 0;\n    background: #fff;\n    z-index: 2;\n  }\n  \n  \n  \n  /* Responsive behavior */\n  @media (max-width: 768px) {\n    .contain{\n      margin: 20px;\n      margin-top: 0px;\n     }\n\n    .view-attendance-heading {\n      display: none;\n    }\n  \n    .hide-on-mobile {\n      display: none;\n    }\n  \n    .mobile-scroll-table-wrapper {\n      display: block;\n    }\n\n    .desktop-table-wrapper {\n      display: none;\n    }\n  \n    .mobile-scroll-table {\n      display: block;\n      overflow-x: auto;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
